
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import App from './App'
import router from './router'
import db from './db'
import VueWebP from 'v-webp'
import storage from 'vue-localstorage'
import VueAnalytics from 'vue-analytics'
import Airbrake from 'airbrake-js'

var settings = require('./settings/' + process.env.NODE_ENV + '.json')

Vue.use(VueAnalytics, {
  id: settings.analytics
})

Vue.use(VueWebP)
Vue.use(db)
Vue.config.productionTip = false
Vue.use(storage)

Vue.use(storage, {
  name: 'ls',
  bind: true
})

Vue.use(VueAnalytics, {
  id: settings.analytics
})

var errbit = new Airbrake({
  projectId: 1,
  projectKey: settings.tracking.key,
  host: settings.tracking.host,
  environment: process.env.NODE_ENV
})

Vue.prototype.$err = async function (error) {
  var params = {}

  if (error !== null && typeof error === 'object') {
    if (error.response !== null && typeof error.response !== 'undefined' && error.response.data !== null && typeof error.response.data !== 'undefined') {
      params.info = error.response.data
    }

    if (error.name !== null && typeof error.name !== 'undefined') {
      params.name = error.name
    }
  }

  await errbit.notify({
    error: error,
    params
  })
}

Vue.use(Vuetify, {
  theme: {
    primary: '#558B2F',
    secondary: '#9E9D24',
    accent: '#AEEA00',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  data: {
    trySync: true
  }
})



// WEBPACK FOOTER //
// ./src/main.js